import { render, staticRenderFns } from "./loExtend.vue?vue&type=template&id=6864ac06&scoped=true&"
import script from "./loExtend.vue?vue&type=script&lang=js&"
export * from "./loExtend.vue?vue&type=script&lang=js&"
import style0 from "./loExtend.vue?vue&type=style&index=0&id=6864ac06&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6864ac06",
  null
  
)

export default component.exports